import { inject } from 'inversify';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { urlMaker } from '@core/utils';
import { bind } from '@infra/container';

export type IExportInspectionReportRepoResponse = IRepoResponse<200, Blob> | IRepoResponse<400 | 500, string>;

export type IExportInspectionReportRepo = IRepo<[string], IExportInspectionReportRepoResponse>;

export const ExportInspectionReportRepoType = Symbol.for('ExportInspectionReportRepo');

@bind(ExportInspectionReportRepoType)
export class ExportInspectionReportRepo implements IExportInspectionReportRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(id: string) {
    try {
      const result = await this.httpClient.get({
        url: urlMaker(`/api/admin/branch_inspections/${id}/export`),
      });

      if (result.status === 200) {
        const blob = await result.blob();

        if (blob) {
          return {
            status: 200 as 200,
            response: blob,
          };
        } else {
          return {
            status: 400 as 400,
            response: 'Excel faylı yaradıla bilmədi',
          };
        }
      } else {
        return {
          status: 400 as 400,
          response: 'Excel faylı yaradıla bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi',
      };
    }
  }
}
